import { Link } from "react-router-dom";
import { COLLECTIONS } from "../data/collections";
import { useApp } from "../context/AppContext";
import { Heart } from "lucide-react";
import { PRICE } from "../data/collections";

export default function Wishlist() {
  const { wishlist, toggleWish } = useApp();
  const items = COLLECTIONS.filter((c) => wishlist.includes(c.slug));

  return (
    <div className="pt-32 pb-24 px-5 md:px-10" data-testid="wishlist-page">
      <div className="mx-auto max-w-[1280px]">
        <p className="eyebrow mb-3">Wishlist</p>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-[-0.03em]">
          Frames you <span className="italic">love.</span>
        </h1>

        {items.length === 0 ? (
          <div className="mt-16 text-center" data-testid="wishlist-empty">
            <Heart className="w-10 h-10 mx-auto opacity-30 mb-4" />
            <p className="font-serif text-3xl mb-3">Nothing here yet.</p>
            <p className="text-[#595955] mb-8">Tap the heart on any frame to save it.</p>
            <Link to="/collections" className="inline-flex items-center gap-2 rounded-full bg-[#2C2C2A] text-[#FAFAF7] px-6 py-3 text-sm font-medium">
              Browse collections →
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7 mt-12">
            {items.map((c) => (
              <div key={c.slug} className="relative">
                <Link to={`/collection/${c.slug}`} className="group block rounded-[24px] overflow-hidden bg-[#F3EADA] lift" data-hover="true">
                  <div className="aspect-[4/5] overflow-hidden">
                    <img src={`/products/${c.slug}-kid.jpg`} alt={c.name} className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-[1200ms]" loading="lazy" />
                  </div>
                  <div className="px-5 py-4 flex items-center justify-between">
                    <div>
                      <h3 className="font-serif text-2xl">{c.name}</h3>
                      <p className="text-[12px] text-[#595955]">{c.audience}</p>
                    </div>
                    <span className="text-sm font-medium">{PRICE}</span>
                  </div>
                </Link>
                <button
                  onClick={() => toggleWish(c.slug)}
                  aria-label="Remove from wishlist"
                  className="absolute top-3 right-3 w-9 h-9 rounded-full bg-[#FAFAF7]/95 backdrop-blur inline-flex items-center justify-center hover:bg-[#2C2C2A] hover:text-[#FAFAF7] transition-colors"
                  data-testid={`wishlist-remove-${c.slug}`}
                >
                  <Heart className="w-4 h-4 fill-current" />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
